<template>
  <div class="center">
    <!-- <div class="info_item_box">
      <p class="label">当前运行设备数</p>
      <p class="num">176,768</p>
    </div>
    <div class="info_item_box item2">
      <p class="label">当前运行设备数</p>
      <p class="num">176,768</p>
    </div>
    <div class="info_item_box">
      <p class="label">当前运行设备数</p>
      <p class="num">176,768</p>
    </div> -->
    <div class="info_item_box item2" v-for="(item, i) in dataArr" :key="i">
      <p class="label">{{ item.label }}</p>
      <p class="num">{{ item.value }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dataArr: [],
    };
  },
  mounted() {
    if (this.itemData && this.itemData.viewId) {
      this.getChartData(this.itemData.viewId);
    }
  },

  methods: {
    async getChartData(viewId) {
      const { data } = await this.$api.getChartData({
        id: viewId,
      });
      const { legend, seriesDataList, xAxisData } = data;
      this.dataArr = seriesDataList[0].dataList.map((el, i) => {
        return {
          label: xAxisData[i],
          value: el,
        };
      });

      console.log("dataArr", this.dataArr);
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  display: block;
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.center {
  width: 100%;
  height: 100%;
  text-align: left;
  position: relative;
  background-image: url("../../../assets/theme/one/center2.png");
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  // line-height: 45px;
  // font-size: 20px;
  // padding-left: 40px;
  // box-sizing: border-box;
  text-align: center;

  .info_item_box {
    width: 204px;
    height: 78px;
    display: inline-block;
    background-image: url("../../../assets/theme/one/info_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    margin-top: 50px;

    .label {
      line-height: 30px;
      font-size: 18px;
      font-family: zihun58hao;
      font-weight: normal;
      color: #ffffff;
    }
    .num {
      //       width: 113px;
      // height: 30px;
      line-height: 45px;
      font-size: 30px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #ffba01;
    }
  }

  .item2 {
    margin: 0 50px;
  }
}
</style>
